import React from 'react';

function round001(x) {
  return Math.round(x * 100) / 100;
}

// Component for rating a single Strategic Life Unit
const StrategicLifeUnitRater = ({ unit, importance, satisfaction, onSLUChange }) => {
  // Handle the changes locally, then propagate them up to the parent component
  const handleImportanceChange = (e) => {
    onSLUChange(unit, e.target.value, satisfaction);
  };

  const handleSatisfactionChange = (e) => {
    onSLUChange(unit, importance, e.target.value);
  };

  return (
    <div className="slu-rater">
      <h3>{unit}</h3>
      <div className="input-group">
      <label>
        Importance:
        <input
          type="number"
          min="0"
          max="10"
          step="0.5"
          value={round001(importance)}
          onChange={handleImportanceChange}
        />
      </label>
      </div>
      <div className="input-group">
      <label>
        Satisfaction:
        <input
          type="number"
          min="0"
          max="10"
          step="0.5"
          value={round001(satisfaction)} 
          onChange={handleSatisfactionChange} 
        />
      </label>
      </div>
    </div>
  );
};

// Component for rating a Strategic Life Area that contains multiple SLUs
const StrategicLifeAreaRater = ({ area, units, onSLUChange, sluValues }) => {
  return (
    <div className="sla-rater">
      <h2>{area}</h2>
      {units.map((unit) => (
        <StrategicLifeUnitRater 
          key={unit} 
          unit={unit} 
          importance={sluValues[unit]?.importance || 5} 
          satisfaction={sluValues[unit]?.satisfaction || 5} 
          onSLUChange={(unit, importance, satisfaction) => onSLUChange(unit, importance, satisfaction)}
        />
      ))}
    </div>
  );
};

export default StrategicLifeAreaRater;
